import { PoweredByLogoTag } from '../../components/PoweredBy/PoweredByLogoTag';
import * as Styled from '../../components/PoweredBy/PoweredBy.styled';
import { Spacer } from '../../helpers/genericStyles';

type PoweredByInfoTitleProps = {
  title: string;
  description: string;
  showPoweredByLogo?: boolean;
};

export const PoweredByInfoTitle = (props: PoweredByInfoTitleProps) => {
  const { showPoweredByLogo = true } = props;
  return (
    <Styled.Grid>
      <Styled.AllianzInfoTitle {...props} />
      <Spacer marginBottom={'S8'} />
      {showPoweredByLogo && <PoweredByLogoTag />}
    </Styled.Grid>
  );
};
